var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Watch } from 'vue-property-decorator';
import { beforeWeektDate } from "../../../helper/defaultDate";
import { getDateAtZeroPoint } from '../../../helper/dateUtil';
import CommonService from '../../../api/CommonService';
function getInitFormData() {
    var initFormData = {
        shop_ids: [],
        is_payment_confirm: 0,
        t: 0,
        s_time: beforeWeektDate().Start.format('yyyy-MM-dd'),
        e_time: beforeWeektDate().End.format('yyyy-MM-dd'),
        keyword: '',
        keyword_type: 1
    };
    return initFormData;
}
var OnlinePayHeader = (function (_super) {
    __extends(OnlinePayHeader, _super);
    function OnlinePayHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.statusOptions = [
            { id: -1, label: '全部状态' },
            { id: 0, label: '待确认' },
            { id: 1, label: '已确认' }
        ];
        _this.noteTypeOptions = [
            { id: 0, label: '全部交易类型' },
            { id: 1, label: '订单支付' },
            { id: 2, label: '售后退款' }
        ];
        _this.shopList = [];
        _this.formData = __assign({}, getInitFormData());
        _this.startPickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        return _this;
    }
    OnlinePayHeader.prototype.watch_s_time = function (newValue, oldValue) {
        this.endPickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var start = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() < start.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    OnlinePayHeader.prototype.watch_e_time = function (newValue, oldValue) {
        this.startPickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var end = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() > end.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    OnlinePayHeader.prototype.created = function () {
        this.commonService = CommonService.getInstance();
    };
    OnlinePayHeader.prototype.mounted = function () {
        this.getShop();
        this.search();
    };
    OnlinePayHeader.prototype.getShop = function () {
        var _this = this;
        this.commonService
            .getShop({
            area_ids: '',
            real: '0',
        })
            .then(function (res) {
            _this.shopList = res.data.data;
        })
            .catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    OnlinePayHeader.prototype.normalizerShop = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    OnlinePayHeader.prototype.search = function () {
        this.$emit('search', this.formData);
    };
    OnlinePayHeader.prototype.search = function () {
        this.$emit('search', this.formData);
    };
    OnlinePayHeader.prototype.reset = function () {
        this.formData = __assign({}, getInitFormData());
    };
    OnlinePayHeader.prototype.exportData = function () {
        this.$emit('exportOnlinePayData', this.formData);
    };
    OnlinePayHeader.prototype.confirmPay = function () {
        this.$emit('openDio', 3);
    };
    __decorate([
        Watch("formData.s_time", { immediate: true })
    ], OnlinePayHeader.prototype, "watch_s_time", null);
    __decorate([
        Watch("formData.e_time", { immediate: true })
    ], OnlinePayHeader.prototype, "watch_e_time", null);
    OnlinePayHeader = __decorate([
        Component({})
    ], OnlinePayHeader);
    return OnlinePayHeader;
}(Vue));
export default OnlinePayHeader;
